export default "__VITE_ASSET__Di0yu0pc__"